// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qv-0";